import { useEffect } from 'react';

function TestSsoCallback() {

  useEffect(() => {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        { type: 'SSO_SUCCESS' },
        window.location.origin
      );
      window.close();
    } else {
      window.location.replace("/");
    }
  }, []);

  return <div></div>;
}

export default TestSsoCallback;
